// extracted by mini-css-extract-plugin
export var downArrow = "_ic-0";
export var infoTooltipIcon = "_ic-3";
export var label = "_ic-1";
export var optionCard = "_ic-4";
export var upArrow = "_ic-2";